import { getInstance } from '@/auth'
import fetch from '@/fetch'

export default {
  getAll() {
    const instance = getInstance()
    const groups =
      (instance.user && instance.user['https://tenants.kvass.no/claims/groups']) || []
    if (!groups.length) return Promise.resolve([])

    const query = groups.map(g => 'groups=' + encodeURIComponent(g)).join('&')
    return fetch('/api/tenant?' + query).then(res => res.json())
  },
}
